import api from "../index";

export const GetAllCountryApi = () => api.get("dropdown/getcountry");
export const GetTermsAndConditionApi = () => api.get(`TermsAndCondition/get`);
